<template>
  <div>
    <p>設法shopline後台找到會員的id(url上),再設法找到此帳號想繼承電子票的舊MI(尚峪與mana後台找),然後執行合併</p>
    <b-form-input class="col-md-6 d-inline" v-model="shopline_user_id" placeholder="輸入shopline 24碼會員id" />
    <b-form-input class="col-md-6 d-inline" v-model="source_member_id" placeholder="輸入16碼合併對象MI" />
    <b-form-textarea v-model="merge_remark" placeholder="備註"></b-form-textarea>
    <b-button @click="doMerge" >執行合併</b-button>
  </div>
</template>

<script>
import {
  apiShoplineMemberMerge
} from '@/api/CustomerServices.js'

export default {
  name: 'MemberProcess',
  components: {

  },
  data: function () {
    return {
      shopline_user_id:"",
      source_member_id:"",
      merge_remark:""
    }
  },
  props: [

  ],
  methods: {
    doMerge() {
      if (!this.shopline_user_id || !this.source_member_id) {
        this.$bus.fnShowInfo("shopline user id與來源mi都必填")
        return;
      }
      if (this.shopline_user_id.length !== 24 || this.source_member_id.length !== 16) {
        this.$bus.fnShowInfo("格式不對(請不要貼到空白)")
        return;
      }
      let Param = {
        'module':'customer_service',
        'method':'shoplineMemberMerge',
        'shopline_user_id':this.shopline_user_id,
        'source_mi':this.source_member_id,
        'remark':this.merge_remark
      }
      let vm = this
      apiShoplineMemberMerge(Param).then(function(resp){
        vm.$bus.fnShowInfo("執行成功");
        vm.shopline_user_id = "";
        vm.source_member_id = "";
        vm.merge_remark = "";
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
          return
        }
      })
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
      //       return
      //     }
      //     vm.$bus.fnShowInfo("執行成功");
      //     vm.shopline_user_id = "";
      //     vm.source_member_id = "";
      //     vm.merge_remark = "";
      // },this)
    }
  },
  computed: {
    
  },
  created: function () {
    // 抓api拿merchant
    // this.loadMerchants()
  },
  mounted () {
    
  },
  watch:{

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.tooltip-wrapper {
  display: inline-block;
}
.tooltip-wrapper >>> b-button {
  pointer-events: none;
}
</style>
